import { noop } from 'lodash'
import { createContext, useContext, useState } from 'react'
import { JobAutomationVehicleInput } from '~/gql/generated/graphql'

type AutomationCtx = {
  expectedJobsMap: Map<string, JobAutomationVehicleInput[]>
  setExpectedJobsMap: React.Dispatch<
    React.SetStateAction<Map<string, JobAutomationVehicleInput[]>>
  >
  shouldPoll: boolean
  setShouldPoll: React.Dispatch<React.SetStateAction<boolean>>
}

export const AutomationContext = createContext<AutomationCtx>({
  expectedJobsMap: new Map(),
  setExpectedJobsMap: noop,
  shouldPoll: false,
  setShouldPoll: noop,
})

export const useAutomationContext = () => useContext(AutomationContext)

export default ({ children }) => {
  const [expectedJobsMap, setExpectedJobsMap] = useState<
    Map<string, JobAutomationVehicleInput[]>
  >(new Map())
  const [shouldPoll, setShouldPoll] = useState(false)

  return (
    <AutomationContext.Provider
      value={{ expectedJobsMap, setExpectedJobsMap, shouldPoll, setShouldPoll }}
    >
      {children}
    </AutomationContext.Provider>
  )
}
